import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipTogetherExistsErrorTitle: {
    description: 'Title stating the user cannot combine shipments',
    defaultMessage: 'Cannot Combine Shipments',
    id: 'ZieQaR',
  },
  shipTogetherSucceededButRefreshFailed: {
    description: 'shown to the user when we succeed in combining shipments for them but we fail to refresh the data they see',
    defaultMessage:
      'We successfully combined the shipments but could not display the changes. Please <refresh>refresh</refresh> to view changes.',
    id: 'c5hyFG',
  },
  fallbackErrorMessageForFailedCombine: {
    description: 'message alerting user that there was an error and suggests next steps',
    defaultMessage: 'An unknown error occurred. Please try again later and contact support if the error occurs again.',
    id: '1bNHMi',
  },
  salesOrderIdEmpty: {
    description: 'Error notifying the user that there is a missing sales order when trying to combine orders',
    defaultMessage: "'Sales Order Id' should not be empty.",
    id: '5wab1V',
  },
  quantityGreaterThanOne: {
    description: 'Error stating that the amount must be greater zero',
    defaultMessage: "'Quantity' must be greater than or equal to '1'.",
    id: '3CHRvU',
  },
});
